<template>
  <div
    class="row"
    v-if="userData.image_url"
  >

    <label
      for="file-upload"
      class="small"
						data-test="profileHeaderUserImgLabel"
						id="profileHeaderUserImgLabel"
    >
      <div class="display-picture">
        <img
          :src=userData.image_url
          alt="profile pic"
          style="width: 100px ; height: 100px; border-radius: 50%; object-fit: cover"
										data-test="profileHeaderUserImg"
										id="profileHeaderUserImg"
        />
      </div>
      <input
        type="file"
        @change="uploadPhoto"
        id="file-upload"
        style="display: none"
        accept="image/*"
								data-test="profileHeaderUserImgInput"
      />
    </label>
    <div
      class="col d-flex align-items-center"
      v-if="!($route.path === '/user/account')"
    >
      <h5 class="capitalize pt-2"
										data-test="profileHeaderUserName"
										id="profileHeaderUserName">
        {{userData.firstname}} {{userData.lastname}}
      </h5>

      <!--<div>-->
      <!--<a href="#"-->
      <!--class="small"-->
      <!--@click="removeProfilePhoto"-->
      <!--id="link2"-->
      <!--&gt;-->
      <!--Remove Profile Photo-->
      <!--</a>-->
      <!--</div>-->
    </div>
    <div
      class="pl-2"
      v-else
    >
      <h6 class="capitalize pt-2"
										data-test="profileHeaderUserInfoName"
										id="profileHeaderUserInfoName">
        {{userData.firstname}} {{userData.lastname}}
      </h6>
      <div class="small"
											data-test="profileHeaderUserInfoPhnNo"
											id="profileHeaderUserInfoPhnNo">
        {{ userData.phone_number }}
      </div>
      <br>
      <div class="small"
											data-test="profileHeaderUserInfoEmail"
											id="profileHeaderUserInfoEmail">
        {{ userData.email}}
      </div>
    </div>
  </div>
  <div
    class="row"
    v-else
  >
    <label
      for="file-upload1"
      class="small"
						data-test="profileHeaderUserInfoImgLabel"
						id="profileHeaderUserInfoImgLabel"
    >
      <div class="display-picture">
        <i class="fas fa-camera"
											data-test="profileHeaderUserFavIcon"
											id="profileHeaderUserFavIcon"></i>
        <img
          src="@/assets/img/no-profile-image.png"
          alt="profile pic"
          style="width: 100px ; height: 100px; border-radius: 50%; object-fit: cover"
										data-test="profileHeaderUserInfoImg"
										id="profileHeaderUserInfoImg"
        />
      </div>
      <input
        type="file"
        @change="uploadPhoto"
        id="file-upload1"
        style="display: none"
        accept="image/*"
								data-test="profileHeaderUserUploadImg"
      />
    </label>
    <div
      class="col"
      v-if="!($route.path === '/user/account')"
    >
      <br>
      <h5 class="capitalize pt-2"
										data-test="profileHeaderUserFirstNameLastName1"
										id="profileHeaderUserFirstNameLastName1">
        {{userData.firstname}} {{userData.lastname}}
      </h5>

    </div>
    <div
      class="pl-2"
      v-else
    >
      <h5 class="capitalize pt-2"
										data-test="profileHeaderUserFirstNameLastName2"
										id="profileHeaderUserFirstNameLastName2">
        {{userData.firstname}} {{userData.lastname}}
      </h5>
      <label class="small"
													data-test="profileHeaderUserPhnNo1"
													id="profileHeaderUserPhnNo1">
        {{ userData.phone_number }}
      </label>
      <br>
      <label class="small"
													data-test="profileHeaderUserEmail1"
													id="profileHeaderUserEmail1">
        {{ userData.email}}
      </label>
    </div>
  </div>
</template>

<script>
import { customerApi } from '@/services/ApiServices/customerApi'

export default {
	name: 'profile-header',
	data () {
		return {
			selectedFile: null
		}
	},
	props: {
		userData: {}
	},
	methods: {
		uploadPhoto (event) {
			this.showBrowse = false
			const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i
			if (!allowedExtensions.exec(event.target.value)) {
				this.$toasted.show('Images of non specified type cannot be uploaded.')
			} else {
				this.selectedFile = event.target.files[0]
				const fd = new FormData()
				fd.append('profile_picture', this.selectedFile, this.selectedFile.name)
				customerApi.uploadProfilePic(fd).then((res) => {
					this.userData.image_url = res.bodyText
					customerApi.updateCustomer(this.userData)
				})
				this.$forceUpdate()
			}
		},
		updatePhoto (event) {
			this.showBrowse = false
			const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i
			if (!allowedExtensions.exec(event.target.value)) {
				this.$toasted.show('Images of non specified type cannot be uploaded.')
			} else {
				this.selectedFile = event.target.files[0]
				const fd = new FormData()
				fd.append('profile_picture', this.selectedFile, this.selectedFile.name)
				customerApi.updateProfilePic(fd).then((res) => {
					this.userData.image_url = res.bodyText
					customerApi.updateCustomer(this.userData)
				})
				this.$forceUpdate()
				this.showBrowse = false
			}
		},
		removeProfilePhoto () {
			customerApi.removeProfilePic(this.userData.image_url).then((res) => {
				this.userData.image_url = ''
				customerApi.updateCustomer(this.userData)
			})
		}
	}
}
</script>

<style scoped>
</style>
